import i18next from 'i18next';

i18next.addResources('en', 'CreateProductionProcessModal', {
  title: 'Are you sure?',
  description: 'You are now going to create a\nnew production process on the Blockchain.',
  confirm: 'Confirm',
  cancel: 'Cancel'
});
